<div class="partner-picker">
  <ng-container *ngIf="selected; else pickerBody">
    <div class="selected-partner" data-testid="selected-partner">
      <span>{{ selected.name }}</span>
      <button type="button" class="link-btn" (click)="clear()" aria-label="Change partner">Change</button>
    </div>
  </ng-container>

  <ng-template #pickerBody>
    <label class="picker-label">Choose your partner</label>

    <input
      type="text"
      class="picker-search"
      data-testid="partner-search"
      placeholder="Search by name or username…"
      [ngModel]="searchTerm"
      (ngModelChange)="onSearchChange($event)" />

    <ul class="picker-list" *ngIf="searchResults.length > 0" data-testid="search-results">
      <li *ngFor="let p of searchResults" (click)="choose(p)">{{ displayName(p) }}</li>
    </ul>

    <div class="picker-section" *ngIf="friends.length > 0">
      <span class="picker-subhead">Friends</span>
      <ul class="picker-list" data-testid="friends-list">
        <li *ngFor="let f of friends" (click)="choose(f)">{{ displayName(f) }}</li>
      </ul>
    </div>
  </ng-template>
</div>
